<template>
  <div class="flex flex-col items-start gap-3 self-stretch">
    <div v-if="store.formId" class="flex items-start gap-4 self-stretch">
      <UISwitch
        :value="store.payment?.recurringDonation?.isRecurringDonationEnabled"
        @update:value="suggestionUpdate"
      ></UISwitch>
      <div>{{ t("common.payment.recurringPayments") }}</div>
    </div>
    <UICheckboxGroup
      v-if="store?.payment?.recurringDonation?.isRecurringDonationEnabled"
      v-model:value="store.payment.recurringDonation.recurringDonationFrequency"
      :disabled="false"
      :default-value="undefined"
      @update:value="handleChange"
    >
      <UICheckbox
        v-for="frequency in recurringDonationFrequency"
        :id="frequency.value"
        :key="frequency.value"
        :value="frequency.value"
        :label="frequency.label"
      />
    </UICheckboxGroup>
  </div>
</template>

<script setup lang="ts">
import { useAppStore } from "@/store/app";
import { RECURRING_DONATION_FREQUENCIES } from "@/util/productConstants";
import { UICheckbox, UICheckboxGroup, UISwitch } from "@gohighlevel/ghl-ui";
import { ref } from "vue";
import { useI18n } from "vue-i18n";
const store = useAppStore();
const { t } = useI18n();

const suggestionUpdate = (isSuggested) => {
  store.payment.recurringDonation.isRecurringDonationEnabled = isSuggested;
  store.addToHistory();
  store.anyUnsavedChanges = true;
};

const recurringDonationFrequency = ref<{ label: string; value: string }[]>(
  RECURRING_DONATION_FREQUENCIES
);

const handleChange = (value: string[]) => {
  const sortedFrequency = [];
  value.forEach((item) => {
    switch (item) {
      case "once":
        sortedFrequency[0] = item;
        break;
      case "day":
        sortedFrequency[1] = item;
        break;
      case "week":
        sortedFrequency[2] = item;
        break;
      case "month":
        sortedFrequency[3] = item;
        break;
      case "year":
        sortedFrequency[4] = item;
        break;
      default:
        sortedFrequency.push(item);
        break;
    }
  });
  store.payment.recurringDonation.recurringDonationFrequency = sortedFrequency.filter(
    (item) => item !== undefined
  );
  store.addToHistory();
  store.anyUnsavedChanges = true;
};
</script>
